/**
 * @categoryDescription Primary exports
 *
 * These are the main exports of this package. You would typically use these
 * when creating SVGs with the default theme configuration.
 *
 * @packageDocumentation
 */
export * from './ThemedExternalSvg.js';
